

import * as React from 'react';

import { BrandingImage } from '../cirium/BrandingImage';
import { NoHrefLink } from '../cirium/NoHrefLink';
import { performLogout } from '../../utils/logoutUtils';

import {
  Box,
  Flex,
  SignOutIcon,
  Text,
  thc,
} from '@flightstats/airframe-react';

const Header = thc(Flex, {
  as: 'header',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  bg: 'eclipse',
  p: '18px 8px',
}) as React.FC<{ children: React.ReactNode }>;

const AppBranding = thc(Box, {
  maxHeight: '70px',
  maxWidth: '260px',
  pr: '10px',
}) as React.FC<{ children: React.ReactNode }>;

const AppBrandingTextWrapper = thc(Flex, {
  alignItems: 'center',
  alignSelf: {
    xs: 'flex-start',
    sm: 'center',
  },
  m: {
    xs: '0',
    sm: '0 auto',
  },
}) as React.FC<{ children: React.ReactNode }>;

const AppControls = thc(
  Flex,
  {
    display: 'flex',
    height: '100%',
  },
  {
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
) as React.FC<{ children: React.ReactNode }>;

const AppText = thc(
  Text,
  {
    alignSelf: 'center',
    color: 'white',
    whiteSpace: {
      xs: 'normal',
      sm: 'nowrap',
    },
  },
  {
    textTransform: 'uppercase',
  },
) as React.FC<{ children?: React.ReactNode }>;

const IconLink = thc<any>(NoHrefLink, {
  display: 'flex',
  variant: 'none',
  mx: '8px',
});

type Props = {
  brandingImageUrl?: string,
  logout?: () => void,
  appName?: string,
};

export const CiriumHeader = (props: Props) => {
  const handleLogout = () => {
    if (props.logout) {
      // If a custom logout function is provided, use it
      props.logout();
    } else {
      // Otherwise use the default logout with cache cleanup
      performLogout();
    }
  };

  return (
    <Header>
      <AppBrandingTextWrapper>
        {props.brandingImageUrl && (
          <AppBranding>
            <BrandingImage display="flex" url={props.brandingImageUrl} />
          </AppBranding>
        )}
        <AppText>{props.appName}</AppText>
      </AppBrandingTextWrapper>
      <AppControls>
        <IconLink
          trackingLabel="Header Sign Out Link"
          ariaLabel="Sign Out"
          onClick={handleLogout}
        >
          <SignOutIcon color="white" height="24px" width="24px" />
        </IconLink>
      </AppControls>
    </Header>
  );
};
